const subtitles = [
  "Freeze your rewards. Focus to thaw them.",
  "Put your phone face-down and let your focus melt the ice.",
  "A focus timer that rewards you instead of nagging you.",
];

const introduction = [
  {
    type: "text/main_title_subtitle",

    verticalAlign: "center",
    horizontalAlign: "center",

    titles: ["Thaw"],
    subtitles,
    textStyle: {
      textAlign: "center",
      paddingLeft: "1em",
      paddingRight: "1em",
    },
  },
];

const description = [
  {
    type: "text/title_subtitle",

    titles: ["Every Ice Cube Is a Reward"],
    subtitles: [
      "Each ice cube in Thaw is a treat you have promised yourself: a video break, a coffee run, a walk outside. Drop it into your glass, place your phone face-down and your focus warms the drink until the ice melts and the reward is yours. Pick the phone up and the drink cools, so the melting waits until you settle back in.",
    ],
    textStyle: {
      textAlign: "center",
      paddingLeft: "1em",
      paddingRight: "1em",
    },
  },
];

const screenshot = [
  {
    type: "screenshot/single_enlarged",

    screenshots: [
      {
        src: "thaw/assets/screenshots/drink_home.jpg",
        alt: "Screenshot of the Thaw home screen with a frozen reward cube in a glass",
      },
    ],
    containerStyle: {
      paddingTop: "4em",
    },
  },
];

const mobile_screenshot = [
  {
    ...screenshot[0],
    containerStyle: {},
  },
];

export const thaw_config = {
  name: "Thaw",
  subtitles,
  backgroundColor: "#1C6A99",

  //Vanta
  highlightColor: "#6FD3F2",
  midtoneColor: "#3F9FD0",
  lowlightColor: "#12466B",
  baseColor: "#1C6A99",

  path: "/thaw",

  title: "Thaw: Freeze Your Rewards, Focus to Thaw Them",
  description:
    "Thaw is a focus timer where every ice cube is a reward you promised yourself. Put your phone face-down and your focus warms the drink, melting the ice until the reward is yours.",
  keywords:
    "Thaw, Focus Timer, Focus App, Study Timer, Pomodoro Timer, Deep Work, Phone Face Down, Reward Yourself, Productivity App",

  sections: [
    {
      type: "layout/split_horizontal",
      leftFlex: 5,
      rightFlex: 5,
      contentLeft: [...introduction, ...description],
      contentRight: [...screenshot],
    },
  ],
  mobileSections: [...introduction, ...mobile_screenshot, ...description],
};
